import {SelectorContainer} from './selector-container';
import {SearchContainer} from '../object-search/search-container';

export class TemplateSelectorContainer implements SelectorContainer {
  art: object;
  searchContainer: SearchContainer;
  selectorCallback;
  selectorEnabled: boolean;
}
